module.exports = __webpack_public_path__ + "static/media/master-card.601862f5.png";